import React, { useState } from "react";
import "./PedagogySection.css";

import CommonHeading from "../../common-component/common-heading/CommonHeading";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const cards = [
  {
    title: "AI-Native Learning",
    description:
      "Learn Claude, Perplexity, Lovable, Bolt.new, PostHog, and GA4 through projects that power your Builder Score.",
    image: "/assets/images/online_mba/PedagogySection/AI-Native Learning.png",
  },
  {
    title: "Graduate with a Builder Score",
    description:
      "Develop & deploy AI products, AI agents, and build your own AI venture across 4 semesters.",
    image: "/assets/images/online_mba/PedagogySection/Graduate with a Builder Score.png",
  },
  {
    title: "Learn from a Global Network",
    description:
      "Experience world-class learning with renowned faculty, industry experts, founders, and 60+ global university partnerships.",
    image: "/assets/images/online_mba/PedagogySection/Learn from a Global Network.png",
  },
  {
    title: "The Founder Mindset",
    description:
      "Cultivate the curiosity, resilience, and entrepreneurial thinking needed to build, lead, and innovate in any industry.",
    image: "/assets/images/online_mba/PedagogySection/The Founder Mindset.png",
  },
  {
    title: "Master Skills AI Can't Replace",
    description:
      "Master the human judgment behind every AI build, even when AI isn't there.",
    image: "/assets/images/online_mba/PedagogySection/Master Skills AI Can't Replace.png",
  },
  {
    title: "Mumbai's Business Pulse",
    description:
      "Bringing the vibrant energy, industry exposure, and entrepreneurial spirit of BKC into every session, wherever you learn.",
    image: "/assets/images/online_mba/PedagogySection/6913416e13d3acf1687e0d0c_atlas-campus-hero-image.png",
  },
];

const PedagogySection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="pedagogy_section">
      <div className="container">
        <CommonHeading
          subTitle="Why Professionals Choose"
          title="ATLAS Online MBA"
          description="Designed for real-world relevance, the ATLAS Online MBA combines AI-first learning, the Builder Score, and the Human Edge Index to prepare future-ready leaders."
        />

        <div className="pedagogy_cards">
          {cards.map((card, index) => (
            <div className="pedagogy_card" key={index}>
              <img src={card.image} alt={card.title} />

              <div className="card_overlay">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        <button className="apply_btn" onClick={() => setShowModal(true)}>
          Apply Now
        </button>
      </div>

      <InquiryFormModal show={showModal} onHide={() => setShowModal(false)} />
    </section>
  );
};

export default PedagogySection;
